/**
 * 공유 링크 UTM — 사내 UTM 컨벤션(소문자만, 공백 대신 언더바)에 맞춘 값.
 *
 * 한 번 배포되면 GA4 리포트가 이 문자열에 묶여 소급 변경이 불가능하다 — 값을 바꾸지 말 것.
 *
 * campaign 에 날짜를 붙이지 않는다 — 액션 날짜(yymmdd) 규칙은 사람이 수동으로 공유하는
 * 캠페인(링크드인·뉴스레터)용이고, 이 버튼은 방문자가 아무 때나 누른다.
 */
export const SHARE_UTM = {
  utm_source: 'blog_detail',
  utm_medium: 'website',
  utm_campaign: 'blog_article_share',
} as const;
